import { toast } from 'react-toastify';
import { HOMEPAGE_TOAST_SAVE_ERROR } from './favoriteApi.util';

const HOMEPAGE_PENDING_TOAST_ID = 'homepage-facility-action';
const FACILITY_LOCATION_TOAST_ID = 'facility-location-loading';

const homepageToastOptions = {
  className: 'toast-bg-black',
  position: toast.POSITION.TOP_RIGHT,
} as const;

export const showHomepagePendingToast = (message: string) => {
  if (toast.isActive(HOMEPAGE_PENDING_TOAST_ID)) {
    toast.update(HOMEPAGE_PENDING_TOAST_ID, {
      render: message,
      type: toast.TYPE.INFO,
      autoClose: false,
      hideProgressBar: false,
      className: homepageToastOptions.className,
    });
    return;
  }

  toast.info(message, {
    ...homepageToastOptions,
    toastId: HOMEPAGE_PENDING_TOAST_ID,
    autoClose: false,
    hideProgressBar: false,
  });
};

export const completeHomepagePendingToast = (message: string) => {
  if (!toast.isActive(HOMEPAGE_PENDING_TOAST_ID)) {
    toast.success(message, homepageToastOptions);
    return;
  }

  toast.update(HOMEPAGE_PENDING_TOAST_ID, {
    render: message,
    type: toast.TYPE.SUCCESS,
    className: homepageToastOptions.className,
    autoClose: 4000,
    hideProgressBar: true,
  });
};

export const dismissHomepagePendingToast = () => {
  toast.dismiss(HOMEPAGE_PENDING_TOAST_ID);
};

export const showFacilityLocationPendingToast = (
  message = 'Loading facility location...'
) => {
  if (toast.isActive(FACILITY_LOCATION_TOAST_ID)) {
    toast.update(FACILITY_LOCATION_TOAST_ID, {
      render: message,
      type: toast.TYPE.INFO,
      autoClose: false,
      hideProgressBar: false,
      className: homepageToastOptions.className,
    });
    return;
  }

  toast.info(message, {
    ...homepageToastOptions,
    toastId: FACILITY_LOCATION_TOAST_ID,
    autoClose: false,
    hideProgressBar: false,
  });
};

export const dismissFacilityLocationPendingToast = () => {
  toast.dismiss(FACILITY_LOCATION_TOAST_ID);
};

export const showHomepageSuccessToast = (message: string) => {
  toast.success(message, homepageToastOptions);
};

export const showHomepageErrorToast = () => {
  dismissHomepagePendingToast();
  toast.error(HOMEPAGE_TOAST_SAVE_ERROR, {
    ...homepageToastOptions,
    toastId: 'my-tundra-facility-order-error',
  });
};
